module.exports = __webpack_public_path__ + "assets/img/舒冠母婴.adf9a931.png";